import api from '@/api';
import eventBus from '@/utils/eventBus';
import longText from '@/views/quotationlist/longText';
import { setStore, getStore, isPartnerM, isNotNull, removeStore, isControlled, isNewProduct } from '@/utils/mUtils';
import { productPriceFormat } from '@/utils/numberFormater';
import MoreContent from '@/views/selectproduct/MoreContent';
import ProductNameFormation from '@/views/components/ProductNameFormation';

export const CommonAddition = {
  data () {
    return {
      tableHeight: 350,
      isLoadTbale: false,
      formLabelWidth: '120px',
      dialogFormVisible: false,
      groupNameT: '',
      form: {
        productLine: '',
        productCategories: '',
        productSeries: '',
        lineProperty: [],
        keys: '',
        preproduction: '',
        stopProduction: '',
        productStatus: '',
        isSpecialControlled: false,
        isProductPackage: false,
        showOpticalModule: false
      },
      // 表单验证
      rules: {
        groupName: [
          { required: true, message: this.$t('addConfigModule.enterGroupName'), trigger: 'blur' },
          { max: 40, message: this.$t('addConfigModule.cannotExceedCharacters') }]
        },
      allProdLines: [],
      allProductCategories: [],
      allProductSeries: [],
      allLinePropertyMap: [],
      // 页数
      page: 1,
      rows: 15,
      total: 0,

      ProductInitListVO: [],
      totalDissipation: 0,
      notloading: true,
      ifshow: true,
      fullscreenLoading: true,
      screenWidth: document.body.clientWidth, // 这里是给到了一个默认值 （这个很重要）
      loading: false,
      switchFlgP: true,
      totalRiilPrice: 0,
      isPartner: true,
      loadflg: true,
      userCollection: 'userCollection',
      data: [],
      dialogNoticeVisible: false,
      noticeText: ''
    };
  },
  components: { longText, MoreContent, ProductNameFormation },
  methods: {
    productPriceFormat,
    isNotNull,
    isControlled,
    isNewProduct,
    // 修改配置组名称
    openUserCollection () {
      this.isPartner = isPartnerM();
      this.getProdLineList();
      this.getProductCategories();
      this.getProductSeriesList();
      this.queryUserCollectionList();
      this.dialogFormVisible = true;
    },
    priceFormat (row, column, cellValue) {
      if (row.isRiil && row.retailPriceFloatingRate > 0) {
        if (row.retailPriceFloatingRate > 0) {
          return 'list*' + row.retailPriceFloatingRate;
        }
      }
      if (row.lineId == 25) {
        if (row.productPrice < 1 || row.productPrice == null) {
          return row.sprPriceRatio;
        }
      }
      return this.formatePrice(cellValue);
    },
    formatePrice (cellValue) {
      if (cellValue === 0) {
        return 0;
      }
      if (cellValue) {
        var value = Number(cellValue).toFixed(2);
        var intPart = Math.trunc(value);
        var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        var value2Array = value.toString().split('.');
        if (value2Array.length === 2) {
          var floatPart = value2Array[1]; // 拿到小数部分
          intPartFormat = intPartFormat + '.' + floatPart;
          return intPartFormat;
        } else {
          return intPartFormat;
        }
      }
    },
    // 获取产品线下拉列表
    getProdLineList () {
      api.getProductLineList({ params: { userCollection: this.userCollection, groupType: '' } }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          // console.log(json.data)
          this.allProdLines = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
      });
    },
    // 清空产品线同时清空产品大类，产品系列
    clearLine () {
      // 产品大类
      this.allProductCategories = [];
      this.form.productCategories = '';
      // 产品系列
      this.allProductSeries = [];
      this.form.productSeries = '';
      // 产品分类
      this.allLinePropertyMap = [];
      this.form.lineProperty = [];
    },
    // 选择产品线改变事件
    onProdLineChange () {
      // 清空产品大类、系列选中值
      this.form.productCategories = '';
      this.form.productSeries = '';
      this.form.lineProperty = [];
      this.getProductCategories();
      // 产品系列
      this.allProductSeries = [];
      this.form.productSeries = '';
      if (this.form.productLine != null && this.form.productLine.lineId != null) {
        this.getlineProperty();
      }
      this.getProductSeriesList();
      this.seachForm();
    },
    // 获取产品大类下拉列表
    getProductCategories () {
      let param = {
        params: {
          lineId: this.form.productLine.lineId,
          userCollection: this.userCollection,
          groupType: ''
        }
      };
      api.getProductCategoriesList(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.allProductCategories = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
      });
    },
    // 清空产品大类，同时清空产品系列
    clearCategories () {
      // 重置产品系列列表数据
      this.allProductSeries = [];
      this.form.productSeries = '';
      this.onProdLineChange();
    },
    // 选择产品大类改变事件
    onProductCategoriesChange () {
      // 清空产品系列选中值
      this.form.productSeries = '';
      this.getProductSeriesList();
      this.seachForm();
    },
    // 获取产品系列列表
    getProductSeriesList () {
      let param = {
        params: {
          lineId: this.form.productLine.lineId,
          categoryId: this.form.productCategories.categoryId,
          userCollection: this.userCollection,
          groupType: ''
        }
      };
      api.getProductSeriesList(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.allProductSeries = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
      });
    },
    // 获取产品分裂列表
    getlineProperty () {
      let param = {
        params: {
          lineId: this.form.productLine.lineId
        }
      };
      api.getlineProperty(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          // console.log(this.allLinePropertyMap);
          this.allLinePropertyMap = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
      });
    },
    // 重置搜索框
    resetForm (formName) {
      // 重置产品大类列表数据
      this.allProductCategories = [];
      // 重置产品系列列表数据
      this.allProductSeries = [];
      // 重置产品分类
      this.allLinePropertyMap = [];
      this.$refs[formName].resetFields();
      // removeStore(`AdditionProduct`);
      this.getProdLineList();
      this.getProductCategories();
      this.getProductSeriesList();
      this.seachForm();
    },
    // 搜索功能
    seachForm () {
      this.fullscreenLoading = true;
      this.page = 1;
      let propertyCode = '';
      let fieldFatherID = '';
      if (this.form.lineProperty && this.form.lineProperty.length > 0) {
        propertyCode = this.form.lineProperty[0];
        if (this.form.lineProperty.length == 2) {
          fieldFatherID = this.form.lineProperty[1];
        }
      }
      let param = {
          lineId: this.form.productLine != '' ? this.form.productLine.lineId : '',
          categoryId: this.form.productCategories != '' ? this.form.productCategories.categoryId : '',
          seriesId: this.form.productSeries != '' ? this.form.productSeries.seriesId : '',
          propertyCode: propertyCode,
          fieldFatherID: fieldFatherID,
          keys: this.form.keys,
          preproduction: this.form.preproduction,
          stopProduction: this.form.stopProduction,
          productStatus: this.form.productStatus,
          isSpecialControlled: this.form.isSpecialControlled,
          isProductPackage: this.form.isProductPackage,
          showOpticalModule: this.form.showOpticalModule,
          page: 1,
          rows: 15,
          isServiceFlag: this.configurationGroup.isService
      };
      api.queryUserCollectionList(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.ProductInitListVO = json.data.data;
          this.fullscreenLoading = false;
        } else {
          this.$notify.error(json.err);
        }
      }).catch((e) => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        console.error('e', e);
      });
    },
    queryUserCollectionList () {
      let param = {
          lineId: '',
          categoryId: '',
          seriesId: '',
          keys: '',
          preproduction: this.form.preproduction,
          stopProduction: this.form.stopProduction,
          productStatus: this.form.productStatus,
          isSpecialControlled: this.form.isSpecialControlled,
          isProductPackage: this.form.isProductPackage,
          showOpticalModule: this.form.showOpticalModule
      };
      api.queryUserCollectionList(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.ProductInitListVO = json.data.data;
          this.fullscreenLoading = false;
        } else {
          this.$notify.error(json.err);
        }
      }).catch((e) => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        console.error('e', e);
      });
    },
    // 添加至配置组
    createProductGroupSubItem () {
      if (this.loadflg) {
        this.loadflg = false;
        let productInitListVOS = this.ProductInitListVO.filter((item) => item.purchaseQuantity > 0);
        if (productInitListVOS != null && productInitListVOS.length > 0) {
          let body = {
            typeOptions: 1,
            groupId: this.configurationGroup.groupId,
            productInitListVOS: productInitListVOS
          };
          api.validateProduct(body).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              let data = json.data;
              if (data != null) {
                this.noticeText = data;
                this.dialogNoticeVisible = true;
                this.loadflg = true;
              } else {
                api.createProductGroupSubItem(body).then((res) => {
                  let json = res.data;
                  if (json.status === '200') {
                    this.loadflg = true;
                    // 跳转到已添加产品
                    // this.added();
                    this.$notify.success(this.$t('addConfigModule.addGroupNameSuccess'));
                    this.seachForm();
                  } else {
                    this.loadflg = true;
                    this.$notify.error(json.err);
                  }
                }).catch(() => {
                  this.loadflg = true;
                  this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
                });
              }
            } else {
              this.loadflg = true;
              this.$notify.error(json.err);
            }
          }).catch(() => {
            this.loadflg = true;
            this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
          });
        } else {
          this.loadflg = true;
          this.$notify.error(this.$t('addConfigModule.changeNotProduct'));
        }
      }
    },
    productDesc (val) {
      let cont = '';
      if (this.screenWidth <= 1440) {
        cont = val.length > 20 ? val.substring(0, 20) : val;
        return cont;
      } else {
        cont = val.length > 35 ? val.substring(0, 35) : val;
        return cont;
      };
    },
    changText (row) {
      if (row.ifShow === undefined) {
        this.$set(row, 'ifShow', true);
      } else {
        row.ifShow = !row.ifShow;
      }
    },
    numberChange (index) {
      if (this.ProductInitListVO[index].purchaseQuantity == undefined) {
        this.$set(this.ProductInitListVO[index], 'purchaseQuantity', 1);
        this.$nextTick(() => {
          this.ProductInitListVO[index].purchaseQuantity = 0;
        });
      }
    },
    foo (h, { column }) {
      if (column.label) {
        return (h('span', {},
          [h('span', [column.label]),
            h('button', {
              attrs: { style: 'float:right;color:#3fbbdc;border:none;border-radius:5px;height:2rem' },
              on: {
                click: () => {
                  this.expandDiscribe();
                }
              }
            }, [this.$t('addConfigModule.expandOrCloseAll')])]));
      }
    },
    expandDiscribe () {
      // longText.expandDisc();
      this.switchFlgP = !this.switchFlgP;
      eventBus.$emit('longTextDisc');
    },
    getRiilPrice () {
      // console.log("this.totalRiilPrice",this.totalRiilPrice)
      if (this.totalRiilPrice == 0) {
        api.getRiilProductTotalPriceByProjectId(this.configurationGroup.projectId).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.totalRiilPrice = json.data;
          }
        });
      }
    },
    cancelWind () {
      this.noticeText = '';
      this.dialogNoticeVisible = false;
    },
    goback () {
      this.noticeText = '';
      this.allProductCategories = [];
      // 重置产品系列列表数据
      this.allProductSeries = [];
      // 重置产品分类
      this.allLinePropertyMap = [];
      this.$refs['form'].resetFields();
      this.dialogFormVisible = false;
      eventBus.$emit('getProductQuantity');
      eventBus.$emit('seachForm');
      eventBus.$emit('loadData');
    }

  },
  destroyed () {
    window.onscroll = null;
  }
};
